var render, staticRenderFns
import script from "./stepWizard.vue?vue&type=script&lang=js"
export * from "./stepWizard.vue?vue&type=script&lang=js"
import style0 from "./stepWizard.vue?vue&type=style&index=0&id=70b772e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b772e6",
  null
  
)

export default component.exports